import { createGlobalStyle } from 'styled-components';

import CustomArial from '@/assets/fonts/arial-webfont.ttf';
import Background from '@/assets/icons/cover-images/simple-trivia.png';

const VariationsStyles = createGlobalStyle`
 @font-face {
       font-family: 'CustomArial';
       src: url(${CustomArial});
   }
  
  .generated-images-holder-var25 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1200px;
  }
  
  .image-holder-var25 {
    width: 100%;
    height: 630px;
    padding: 42px 107px 48px;
    background: url(${Background}) no-repeat center center;
    background-size: contain;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }

  .bottom-holder-var25 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 30px;
    grid-row-gap: 1px;
    padding: 0 12px;
  }
  
  .question-var25 {
    line-height: 1.2;
    letter-spacing: 0.8px;
    width: 100%;
    font-size: 48px;
    text-align: center;
    color: #000;
    font-family: CustomArial;
    font-weight: 700;
  }
  
  .trivia-answer-var25  {
    display: flex;
    gap: 14px;
    font-family: CustomArial;
    font-weight: 400;
    font-size: 45px;
    color: #000;
    line-height: 1.2;
  }

   .trivia-answer-var25 span {
   
   }

`;

export default VariationsStyles;
